module.exports = __webpack_public_path__ + "15e839f83f12a25fab989630834dfa7f.fbx";